import React from "react";

/* Header + watermark icon — built from the healthicons "unhealthy-food-outline" artwork */
const FoodIcon = ({ size = 26, color = "#055075", opacity = 1 }) => (
  <svg width={size} height={size} viewBox="0 0 207 207" fill="none" xmlns="http://www.w3.org/2000/svg" opacity={opacity}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M134.671 17.25L129.453 37.26L129.747 32.9044L103.501 45.4581V28.6695L73.3132 37.9069V53.5181L65.6801 25.0427L41.5215 47.6272L52.044 86.8839C52.5442 87.1427 52.9999 87.4704 53.411 87.8672C56.9875 91.3287 60.4375 94.4754 63.761 97.3072L51.1944 50.3916L61.07 41.1628L73.3175 86.8192V104.764C76.2587 106.845 79.1337 108.642 81.9425 110.154V44.2894L94.88 40.3348V115.23C98.1489 115.998 101.399 116.344 104.631 116.269L108.969 52.4012L120.138 47.0537L115.563 114.432C119.261 113.249 122.827 111.686 126.202 109.766L136.237 72.3034L148.484 68.6291L140.032 100.162C144.091 96.826 148.011 93.3226 151.779 89.6612L161.038 55.1008L153.418 57.0501L165.364 17.25H134.671ZM153.767 25.875L143.667 59.547L131.756 62.5916L141.33 25.875H153.767Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M153.478 99.9163C136.435 115.571 120.699 124.937 103.699 124.912C86.6906 124.886 70.8163 115.45 53.5102 99.7783L63.6791 181.125H143.327L153.478 99.9163ZM49.4608 86.25C46.097 86.25 43.4966 89.1998 43.9106 92.5376L55.1231 182.195C55.3836 184.279 56.3962 186.198 57.9708 187.589C59.5454 188.98 61.5737 189.748 63.6748 189.75H143.322C145.424 189.749 147.453 188.981 149.029 187.59C150.604 186.199 151.618 184.28 151.878 182.195L163.091 92.5161C163.239 91.3585 163.02 90.1836 162.465 89.1571C161.91 88.1305 161.047 87.304 159.997 86.7939C158.947 86.2839 157.764 86.116 156.614 86.314C155.464 86.5119 154.405 87.0657 153.586 87.8974C115.032 125.83 92.5254 125.675 53.4067 87.8672C52.3492 86.8421 50.9379 86.263 49.4651 86.25"
      fill={color}
    />
  </svg>
);

const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.5 1.5L12.5 4.5L4.5 12.5H1.5V9.5L9.5 1.5Z" stroke="#3A4A2E" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 3.5H12M5.5 3.5V2C5.5 1.5 5.9 1 6.5 1H7.5C8.1 1 8.5 1.5 8.5 2V3.5M11 3.5L10.5 12C10.45 12.55 10 13 9.4 13H4.6C4 13 3.55 12.55 3.5 12L3 3.5"
      stroke="#3A4A2E" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/* Card background: wave silhouette (Rectangle_4478) + large centered watermark food icon */
const CardBackground = () => (
  <>
    <svg
      viewBox="0 0 338 178"
      preserveAspectRatio="none"
      style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "190px", zIndex: 0 }}
    >
      <path
        d="M1.22579e-09 19.9619C5.69293e-10 8.91622 8.95431 0 20 0H318C329.046 0 338 8.95431 338 20V47C332.02 47.5161 246.008 29.4959 162 71.5C123 91 1.59862e-09 195.5 5.75164e-09 174.5C8.9726e-09 158.213 3.73775e-09 62.2263 1.22579e-09 19.9619Z"
        fill="#C7ECFF"
      />
    </svg>
    <svg
      viewBox="0 0 400 620"
      preserveAspectRatio="none"
      style={{ position: "absolute", inset: 0, width: "100%", height: "100%", zIndex: 0, pointerEvents: "none" }}
    >
      <g transform="translate(200,300)" opacity="0.35">
        <foreignObject x="-104" y="-104" width="207" height="207">
          <div xmlns="http://www.w3.org/1999/xhtml" style={{ width: "207px", height: "207px" }}>
            <FoodIcon size={207} color="#DCEFFA" />
          </div>
        </foreignObject>
      </g>
    </svg>
  </>
);

const styles = {
  outer: {
    position: "relative",
    width: "100%",
    maxWidth: "400px",
    borderRadius: "22px",
    overflow: "hidden",
    background: "#7FA9C7",
    boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
    fontFamily: "inherit",
  },
  header: {
    position: "relative",
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "16px 16px 14px 16px",
    padding: "10px 14px",
    background: "#DCEFFA",
    borderRadius: "16px",
  },
  headerLeft: { display: "flex", alignItems: "center", gap: "10px" },
  title: { fontSize: "16px", fontWeight: 700, color: "#055075", margin: 0 },
  badge: {
    background: "#151515",
    color: "#5FE07A",
    fontSize: "13px",
    fontWeight: 700,
    borderRadius: "12px",
    padding: "3px 14px",
    minWidth: "28px",
    textAlign: "center",
  },
  scrollArea: {
    position: "relative",
    zIndex: 2,
    maxHeight: "420px",
    overflowY: "auto",
    padding: "0 18px 18px 18px",
  },
  item: {
    position: "relative",
    paddingTop: "6px",
  },
  itemHeader: {
    position: "relative",
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "10px",
  },
  itemName: { fontSize: "15px", fontWeight: 700, color: "#101820", margin: 0 },
  itemActions: { display: "flex", gap: "8px" },
  iconBtn: {
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    background: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
    border: "none",
  },
  infoBox: {
    position: "relative",
    zIndex: 2,
    background: "#DCFAF3",
    borderRadius: "14px",
    padding: "12px 16px",
  },
  row: { display: "flex", justifyContent: "space-between", padding: "3px 0" },
  label: { fontSize: "12.5px", color: "#3A4A46" },
  value: { fontSize: "13.5px", fontWeight: 700, color: "#101820" },
  divider: {
    border: "none",
    borderTop: "1.5px dashed rgba(255,255,255,0.65)",
    margin: "16px 0 0 0",
  },
};

const defaultItems = [
  { id: 1, name: "Planner Name", frequency: "30 Days", exerciseLevel: 26 },
  { id: 2, name: "Planner Name", frequency: "30 Days", exerciseLevel: 26 },
  { id: 3, name: "Planner Name", frequency: "30 Days", exerciseLevel: 26 },
  { id: 4, name: "Planner Name", frequency: "30 Days" },
];

const NutritionPlanner = ({ items = defaultItems, count, onEdit, onDelete }) => {
  const total = count ?? items.length;

  return (
    <div style={styles.outer}>
      <style>{`
        .np-scroll::-webkit-scrollbar { width: 5px; }
        .np-scroll::-webkit-scrollbar-track { background: transparent; }
        .np-scroll::-webkit-scrollbar-thumb { background: #E23B3B; border-radius: 10px; }
        .np-scroll { scrollbar-width: thin; scrollbar-color: #E23B3B transparent; }
      `}</style>

      <CardBackground />

      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <FoodIcon size={26} color="#055075" />
          <p style={styles.title}>Active Nutrition Planners</p>
        </div>
        <span style={styles.badge}>{total}</span>
      </div>

      <div className="np-scroll" style={styles.scrollArea}>
        {items.map((it, idx) => (
          <div key={it.id}>
            <div style={styles.item}>
              <div style={styles.itemHeader}>
                <p style={styles.itemName}>{it.name}</p>
                <div style={styles.itemActions}>
                  <button style={styles.iconBtn} onClick={() => onDelete && onDelete(it.id)} aria-label="Delete">
                    <TrashIcon />
                  </button>
                  <button style={styles.iconBtn} onClick={() => onEdit && onEdit(it.id)} aria-label="Edit">
                    <EditIcon />
                  </button>
                </div>
              </div>

              <div style={styles.infoBox}>
                <div style={styles.row}>
                  <span style={styles.label}>Frequency</span>
                  <span style={styles.value}>{it.frequency}</span>
                </div>
                {it.exerciseLevel != null && (
                  <div style={styles.row}>
                    <span style={styles.label}>Exercise level</span>
                    <span style={styles.value}>{it.exerciseLevel}</span>
                  </div>
                )}
              </div>
            </div>

            {idx !== items.length - 1 && <hr style={styles.divider} />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NutritionPlanner;